import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const getNextPurchaseOrderNumberRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/purchase-orders/next-number',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/purchase-orders/next-number' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getNextPurchaseOrderNumberResponse: Json = {
    title: 'RESPONSE',
    json: {
        title: 'THE NEXT ORDER NUMBER OBJECT',
        json: {
            "orderNumber": "1005"
        },
    },
};

const data: RequestDefinitionData = {
    id: 'get-next-purchase-order-number',
    title: 'Get the next purchase order number',
    description: 'Returns the next available purchase order number based on the system\'s auto-numbering settings. '
        + 'Note: calling this endpoint immediately consumes the order number — the number is incremented and '
        + 'reserved regardless of whether a purchase order is subsequently created. '
        + 'Returns a 400 error if purchase order auto-numbering is not enabled; in that case, enable it in the Module '
        + 'Options or supply the order number manually when creating a purchase order.',
    endpoint: {
        verb: 'GET',
        path: '/purchase-orders/next-number',
        tooltip: 'Get the next purchase order number',
    },
    attributes: [],
    requestObject: getNextPurchaseOrderNumberRequest,
    responseObject: getNextPurchaseOrderNumberResponse,
};

export default data;